module.exports = __webpack_public_path__ + "img/collection2.6428f764.png";